export enum EventTypes {
  ALERT_STATUS_UPDATED = 'alertStatus.updated',
  CHANGE_STATUS = 'proposal.changeStatus',
  CLIENT_HOSTED_CONTENT_DISPLAY = 'clientHostedContent.display',
  DEEP_DIVE_CREATE_REPORT = 'deepdive.createReport',
  DEEP_DIVE_VIEW = 'deepdive.view',
  ENROLLMENT_GET_FIRMS = 'enrollment.getFirms',
  ENROLLMENT_GET_GROUPS = 'enrollment.getGroups',
  ENROLLMENT_GET_PICKLIST = 'enrollment.getPicklist',
  MMA_DOCUMENTS_COUNT = 'mma-documents.count',
  MMA_DOCUMENTS_FILTER = 'mma-documents.filter',
  PCO_CREATE_REPORT = 'checkout.createReport',
  PROPOSAL_CREATE_REPORT = 'proposal.createReport',
  PROPOSAL_INITIATE = 'proposal.initiate',
  PROPOSAL_INTRADAY_UPDATE = 'proposal.requestIntradayUpdate',
  PROPOSAL_REFRESH = 'proposal.refresh',
  PROPOSAL_RETRIEVE_ORDERS = 'proposal.retrieveOrders',
  PROPOSAL_SAVE = 'proposal.save',
  PROPOSAL_VIEW = 'proposal.view',
  RELEASE_ORDERS = 'prd.releaseOrders',
}
